<template>
    <div class="text-center" id="noContent">
        <div class="content">
            <div v-if="icon && !$slots.icon" class="mb-1">
                <i :class="['icon fa', icon]"></i>
            </div>
            <slot name="icon"></slot>

            <div v-if="title" class="mb-3">
                <h3>{{ title }}</h3>
            </div>

            <div v-if="text && !$slots.text">
                <p>{{ text }}</p>
            </div>
            <slot name="text"></slot>

            <div v-if="action">
                <basic-button
                    cls="btn-primary mt-3 mb-4"
                    :text="actionText"
                    @click="create(action)"/>
            </div>
            <!--            <a class="help-slug" v-if="helpSlug" :href="getHelpLink()" target="_blank">-->
            <!--                {{ trans('general.page.empty_learn_more') }} <i class="fi fi-rr-arrow-right"></i>-->
            <!--            </a>-->
            <slot name="custom"></slot>
        </div>
    </div>
</template>

<script>
import BasicButton from "../atoms/BasicButton.vue";
import {eventBus} from "../../services/EventBus";

export default {
    name: "NoContentPlaceholder",
    props: {
        icon: {
            type: String,
            required: false,
            default: 'fi-rr-list'
        },
        title: {
            type: String,
            required: false,
            default: trans('general.page.empty_content')
        },
        text: {
            type: String,
            required: false
        },
        helpSlug: {
            type: String,
            required: false
        },
        action: {
            type: String|Function,
            required: false
        },
        actionData: {
            type: Object,
            required: false
        },
        actionText: {
            type: String,
            required: false,
            default: trans('general.page.empty_action_text')
        },
    },
    components: {
        BasicButton
    },
    data() {
        return {
            locale: document.documentElement.lang
        }
    },
    methods: {
        getHelpLink() {
            return `https://www.kidsday.io/${this.locale}/help/${this.helpSlug}`;
        },
        create(action) {
            if (typeof action === 'function') {
                action();
                return;
            }

            const routes = {
                'create': () => this.$emit('create'),
                'development-forms': () => window.location.href = '/development-reports#development_reports',
                'new-teachers': () => window.location.href = '/staff/new',
                'new-parents': () => window.location.href = '/parents/new',
                'new-menu': () => eventBus.$emit('newPlanner', action),
                'new-activity': () => eventBus.$emit('newPlanner', action),
                'new-event': () => eventBus.$emit('newPlanner', action),
                'new-appointment': () => eventBus.$emit('newPlanner', action),
            };

            if (routes[this.action]) {
                routes[this.action]();
            } else {
                eventBus.$emit('callToAction', action, this.actionData);
            }
        }
    },
}
</script>

<style scoped>
#noContent {
    padding: 7vh 10px;
    //background: #F9F9F9;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

#noContent .content {
    max-width: 450px;
}

#noContent i.icon {
    font-size: 80px;
    color: rgb(0 0 0 / 5%);
}

.help-slug {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}
</style>
